// @flow

import styled, { keyframes } from 'styled-components';
import Grid from 'styled-components-grid';

import breakpoint from 'styled-components-breakpoint';
import { mx } from 'styled-components-spacing'; // eslint-disable-line object-curly-newline

import { buttonLight } from '@styles/buttons';

import coverImage from '@images/home/home-fly.svg';
import IconImage from '@images/home/pasport.svg';
import IconOne from '@images/home/person.svg';
import IconTwo from '@images/home/travel.svg';
import IconThree from '@images/home/back-home.svg';
import theme from '@theme';
import { colors } from '@components/ListItemFacility/styles';

const transitionRightToLeft = keyframes`
  from {
    right: -100%;
  }
  to {
    right: 0;
  }
`;

const transitionDownToUp = keyframes`
  from {
    transform: translateY(10%);
  }
  to {
    transform: translateY(0%);
  }
`;

const transitionOpacity = keyframes`
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
`;

export const StyledRightSection = styled.div`
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
`;

export const StyledRightSectionTop = styled.div``;

export const StyledCover = styled(Grid)``;

export const StyledCoverBlock = styled(Grid.Unit)`
  ${({ pl }) => pl && 'padding-left: 20px'};
  ${({ xpr }) => xpr && 'padding-right: 40px'};
  font-size: 18px;
  font-family: 'Roboto';
  font-weight: 500;
  line-height: 1.2;
  color: ${colors.translucentDarkBlue};

  ${breakpoint('mobile', 'desktop')`
    font-size: 16px;
    ${({ mb }) => mb && 'margin-bottom: 40px'};
  `}
`;

export const StyledCoverMaxWidthCustom = styled.div`
  margin: 0 auto;
  background: linear-gradient(172.01deg, #ffffff -1.12%, #ffffff 27.5%, #e2f4f7 74.67%);
  box-shadow: 0px 4px 20px rgba(0, 0, 0, 0.25);

  ${breakpoint('mobile', 'desktop')`
    padding-left: 10px;
    padding-right: 10px;
    width: calc(100% - 20px);
  `}

  ${breakpoint('desktop')`
    max-width: calc(100% - 80px);
  `}
`;

export const StyledCoverInner = styled.div`
  max-width: 1200px;
  margin: 0 auto;
`;

export const StyledBannerRightCover = styled.div`
  width: 100%;
  height: auto;
  background-color: ${colors.lightGray};

  ${breakpoint('desktop')`
    padding-top: 80px;
    padding-bottom: 80px;
  `}

  ${breakpoint('mobile', 'desktop')`
    padding-top: 20px;
    padding-left: 10px;
    padding-right: 10px;
    padding-bottom: 20px;
    width: calc(100% - 20px);
  `}
`;

export const StyledGradient = styled.div`
  position: absolute;
  top: 0;
  left: 0;

  height: 100%;
  width: 100%;

  ${theme.gradients.linearBlueTurquoiseLTR};

  transform-origin: bottom left;
  transform: skew(0, -8deg);
  outline: 1px solid transparent;
  ${breakpoint('desktop')`
    ${theme.gradients.linearTurquoiseBlueTTB}
    width: 54%;
    transform-origin: top left;
    transform: skew(-12deg, 0);
  `}

  ${breakpoint('largeDesktop')`
    width: 51%;
  `}
`;

export const StyledContentCover = styled(Grid.Unit)`
  margin-bottom: 30px;
`;

export const StyledImage = styled(coverImage)`
  width: 100%;
`;

export const StyledIcon = styled(IconImage)`
  width: 100%;
  ${breakpoint('mobile', 'desktop')`
    height: 40px;
  `}
`;
export const StyledIconOne = styled(IconOne)`
  width: 100%;
  ${breakpoint('mobile', 'desktop')`
    height: 40px;
  `}
`;
export const StyledIconTwo = styled(IconTwo)`
  width: 100%;
  align-items: center;
  ${breakpoint('mobile', 'desktop')`
    height: 40px;
  `}
`;

export const StyledIconThree = styled(IconThree)`
  width: 100%;
  align-items: center;
  ${breakpoint('mobile', 'desktop')`
    height: 40px;
  `}
`;

export const StyledLogo = styled.img`
  position: relative;
  max-width: 75%;
  max-height: 100%;
  object-fit: cover;
  margin: auto;
  background-size: cover;
  background-position: center;
  padding-top: 14px;

  ${breakpoint('mobile', 'desktop')`
    padding-top: 10px;
  `}
`;

export const StyledTestimony = styled.img`
  position: relative;
  max-width: 75%;
  max-height: 100%;
  object-fit: cover;
  margin: auto;
  background-size: cover;
  background-position: center;
`;

export const StyledButton = styled.a`
  ${buttonLight}

  ${mx(2.5)}
  background: white;
  justify-content: center;
  text-decoration: none;
  width: fit-content;

  ${({ disabled }) =>
    (disabled
      ? `
    visibility: hidden;
  `
      : '')}

  ${breakpoint('mobile', 'desktop')`
    justify-content: center;
    font-size: 14px;
    font-weight: 600;
    width: 25%;
    box-shadow: none;
    padding: 10px;
   
  `}

  @media (max-width: 600px) {
    width: 26%;
  }

  @media (max-width: 320px) {
    font-size: 12px;
    width: 56%;
  }

  &:hover{
    transform: scale(0.95);
    transition: 0.3s;
`;

export const StyledButtonSec = styled.a`
  ${buttonLight}
  width: fit-content;
  ${mx(2.5)}
  background: none;
  justify-content: center;
  background-color: ${colors.aquaMarine};
  text-decoration: none;
  color: ${colors.white};
  transition: 0.3s;

  ${({ disabled }) =>
    (disabled
      ? `
    visibility: hidden;
  `
      : '')}

  ${breakpoint('mobile', 'desktop')`
    justify-content: center;
    font-size: 14px;
    font-weight: 600;
    width: 25% !important;
    box-shadow: none;
    padding: 10px;
   
  `}

  @media (max-width: 600px) {
    width: 26%;
  }

  @media (max-width: 320px) {
    font-size: 12px;
    width: 56%;
  }

  &:hover{
    transition: 0.3s;
    transform: scale(0.95);
  }
`;

export const StyledMainHeadlineText = styled.h2`
  color: black;
  text-align: center;
  color: ${colors.navyGray};
  font-size: 40px;
  font-weight: 600;
  line-height: 50px;
  padding-top: 50px;
  ${breakpoint('mobile', 'tablet')`
    font-size: 24px;
    font-weight: 600;
    line-height: 30px;
`}
  @media only screen and (max-width: 360px) {
    font-size: 28px;
    padding-left: 3%;
    padding-right: 3%;
  }
  @media only screen and (max-width: 300px) {
    font-size: 25px;
  }
`;

export const StyledHeadlineTextSub = styled.div`
  align-items: center;
  margin-bottom: 60px;
`;

export const LabelTitle = styled.h2`
  margin: 15px 0;
  text-transform: uppercase;
  font-size: 25px;
  color: ${theme.colors.white};
  font-weight: 800;
  position: relative;

  ${breakpoint('desktop')`
    font-size: 36px;
    animation:
      ${transitionDownToUp} ${({ animateTime }) => animateTime}s ease-out 1, 
      ${transitionOpacity} ${({ animateTime }) => animateTime}s ease-in 1
  `}
`;

export const StyledButtonCover = styled.div`
  display: flex;
  flex: 1;
  flex-direction: row;
  justify-content: center;
  align-items: center;


  ${breakpoint('desktop')`
    animation: none;
    animation: ${({ animate }) => (animate ? transitionRightToLeft : 'none')} 1.8s ease-out 1, 
      ${({ animate }) => (animate ? transitionOpacity : 'none')} 1.6s ease-in 1;
  `}

  ${breakpoint('largeDesktop')`
      max-width: unset;
  `}
  
  ${breakpoint('mobile')`
    margin-bottom: 40px;
    width: 100%;
    justify-content: center;
  `}
   @media only screen and (max-width: 300px) {
     {
      padding-left: 5%;
      padding-right: 5%;
    }
`;
